import { BEFORE_NAVBAR, GET_NAVBAR, SET_MENU, BEFORE_MENU } from '../../../redux/types';

const initialState = {
    navBar: null,
    navBarAuth: false,
    menuAuth: false
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_NAVBAR:
            return {
                ...state,
                navBar: action.payload,
                navBarAuth: true
            }
        case BEFORE_NAVBAR:
            return {
                ...state,
                navBar: null,
                navBarAuth: false
            }
        case SET_MENU:
            return {
                ...state,
                menuAuth: true
            }
        case BEFORE_MENU:
            return {
                ...state,
                menuAuth: false
            }
        default:
            return {
                ...state
            }
    }
}